<template>
  <CalicoOnboarding
    :loading="loading"
    :form-data="formData"
    @save="save"
  >
    <div class="personal-contact">
      <CalicoFormHeader />
      <div
        v-if="showBanner"
        class="container-calico-banner"
      >
        <CalicoBanner variant="error">
          <p class="body--medium">
            {{ bannerMessage }}
          </p>
        </CalicoBanner>
      </div>
      <div
        v-if="showEmailBanner"
        class="container-calico-banner"
      >
        <CalicoBanner variant="error">
          <p class="body--medium">
            {{ bannerEmailMessage }}
          </p>
        </CalicoBanner>
      </div>
      <CalicoForm
        v-slot="{ field, error }"
        label="Personal Phone"
        name="personal_phone"
        rules="required"
      >
        <CalicoField 
          v-model="formData.personal_phone" 
          v-bind="field" 
          :error="error" 
          :only-numbers="true"
          placeholder="(555) 555-5555"
        />
      </CalicoForm>
      <CalicoForm
        v-slot="{ field, error }"
        label="Personal Email"
        name="personal_email"
        rules="required"
      >
        <CalicoField
          v-model="formData.personal_email"
          v-bind="field"
          :error="error"
          maxlength="80"
          placeholder="Email"
        />
      </CalicoForm>
      <CalicoForm
        v-slot="{ field, error }"
        label="Home Address"
        name="address"
        rules="required"
      >
        <CalicoField
          v-model="formData.address"
          v-bind="field"
          :error="error"
          maxlength="200"
          placeholder="Home Address"
        />
      </CalicoForm>
      <CalicoForm
        v-slot="{ field, error }"
        label="Address 2"
        name="address_2"
      >
        <CalicoField
          v-model="formData.address_2"
          v-bind="field"
          :error="error"
          maxlength="200"
          placeholder="Address"
        />
      </CalicoForm>
      <CalicoForm
        v-slot="{ field, error }"
        label="City"
        name="city"
        rules="required"
      >
        <CalicoField
          v-model="formData.city"
          v-bind="field"
          :error="error"
          maxlength="100"
          placeholder="City"
        />
      </CalicoForm>
      <CalicoForm
        v-slot="{ field, error }"
        label="State"
        name="state"
      >
        <CalicoDropdown
          v-model="formData.state"
          v-bind="field"
          :error="error"
          :placeholder="selectedStateLabel"
        >
          <CalicoDropdownMenuItem
            v-for="option in states" 
            :key="option.value" 
            :value="option.value"
            class="calico-option body--medium"
            @click="onState(option)"
          >
            {{ option.label }}
          </CalicoDropdownMenuItem>
        </CalicoDropdown>
      </CalicoForm>
      <CalicoForm
        v-slot="{ field, error }"
        label="Zip"
        name="zip"
        rules="required|zip"
      >
        <CalicoField
          v-model="formData.zip"
          v-bind="field"
          :error="error"
          maxlength="5"
          :only-numbers="true"
          placeholder="Zip"
        />
      </CalicoForm>
    </div>
  </CalicoOnboarding>
</template>

<script>
import CalicoFormHeader from "@/components/calico/formHeader/index.vue"
import CalicoOnboarding from "@/components/template/onboarding/index.vue";
import CalicoForm from "@/components/pattern/form/index.vue";
import CalicoField from '@/components/calico/field/index.vue';
import CalicoDropdown from '@/components/calico/dropdown/index.vue';
import CalicoDropdownMenuItem from '@/components/calico/dropdownMenuItem/index.vue';
import CalicoBanner from "@/components/calico/banner/index.vue";
import { states } from "@/constants";
import services from "@/services";
import { formatPhone, normalizePhone } from "@/utils/helper";

export default {
  name: 'PersonalContactScreen',
  components: {
    CalicoFormHeader,
    CalicoOnboarding,
    CalicoField,
    CalicoForm,
    CalicoDropdown,
    CalicoDropdownMenuItem,
    CalicoBanner
  },
  data() {
    return {
      formData: {
        personal_phone: "",
        personal_email: "",
        address: "",
        address_2: "",
        city: "",
        state: "",
        zip: "",
      },
      states,
      loading: true,
      showBanner: false,
      bannerMessage: '',
    };
  },
  computed: {
    selectedStateLabel() {
      const foundState = this.states.find(option => option.value === this.formData.state);
      return foundState ? foundState.label : "Select a State...";
    }
  },
  watch: {
    "formData.personal_phone"(val) {
      const formatted = formatPhone(val);
      if (formatted !== val) this.formData.personal_phone = formatted;
    }
  },
  async mounted() {
    const userDetails = await services.user.details.get();
    this.formData = {
      personal_phone: formatPhone(userDetails.personal_phone),
      personal_email: userDetails.personal_email,
      address: userDetails.address,
      address_2: userDetails.address_2,
      city: userDetails.city,
      state: userDetails.state,
      zip: userDetails.zip
    };
    this.loading = false
  },
  methods: {
    async save(next) {
      this.loading = true

      const payload = {
        ...this.formData,
        personal_phone: normalizePhone(this.formData.personal_phone)
      };

      await services.user.details.post(payload);
      next()
      this.loading = false
    },
    onState(option) {
      this.formData.state = option.value
    }
  }
}
</script>

<style scoped lang="scss">
.personal-contact {
  @include stack-space($space-large);
  padding: $space-large;

  .divider {
    border-top: $border-width-default solid $color-black;
  }

  .container-calico-banner {
    width: 100%;
  }
}
</style>
